<template>
<div class="chapter">
<div class="inner_page">
<div class="preface" id="adc">
<p class="center"><strong>ALSO BY TOM LUTZ</strong></p>
<p class="center"><em>American Nervousness, 1903: An Anecdotal History</em></p>
<p class="center"><em>Crying: The Natural and Cultural History of Tears</em></p>
<p class="center"><em>Cosmopolitan Vistas: American Regionalism and Literary Value</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780865477377_epub_adc_r1.vue?6e028e4d